import { Directive, HostListener } from '@angular/core';
import { BackNavigationService } from './back-navigation.service';

@Directive({
  selector: '[pdNavigateBack]',
  standalone: true,
  providers: [BackNavigationService],
})
export class NavigateBackDirective {
  constructor(private navigation: BackNavigationService) {}

  @HostListener('click')
  onClick(): void {
    this.navigation.back();
  }
}
